







































import { Component, Inject, Model, Prop, Vue, Watch, Provide } from "vue-property-decorator";
import Config from '../../utils/Config';
import Button from '../Button.vue';
import SockController, { SOCK_ACTIONS } from '../../controller/SockController';
import { MESSAGE_TYPE } from '../../vo/ChatMessageData';

@Component({
	components:{
		Button
	}
})
export default class ElemToConst extends Vue {

	public elem1:string = "water";
	public elem2:string = "water";
	public constellation:string = "aquila";

	public get constList():string[] {
		return Config.CONSTELLATION_LIST.sort();
	}

	public mounted():void {
		
	}

	public beforeDestroy():void {
		
	}

	public submit():void {
		let data = {
			type:MESSAGE_TYPE.ELEMS_TO_CONST,
			elem1:this.elem1,
			elem2:this.elem2,
			constellation:this.constellation,
			from:this.$store.state.me.id,
		}
		SockController.instance.sendMessage({action:SOCK_ACTIONS.SEND_MESSAGE, includeSelf:true, data});
	}

}
